import React, { useContext, useEffect } from 'react'
import ReactDOM from 'react-dom'

import { CSSTransition } from 'react-transition-group'

import { ModalContext } from 'src/hooks/modal/context'

import * as styles from './index.module.scss'
import * as transitoin from './transition.module.scss'


const Modal = ({ className, open, children }) => {

    const { setOpen } = useContext(ModalContext)


    useEffect(() => {
        return () => setOpen(false)
    }, [setOpen])

    
    useEffect(() => {
        setOpen(open)
    }, [open, setOpen])


    if (typeof window !== `undefined`) {
        const _className = styles.modal + (className ? ` ${className}` : ``)

        return (
            ReactDOM.createPortal((
                <CSSTransition in={open} timeout={500} unmountOnExit classNames={transitoin}>
                    <div className={_className}>
                        {children}
                    </div>
                </CSSTransition >
            ), document.body)
        )
    } else {
        return null
    }
}


export default Modal